import constants from '../../ahm-constants';

const { CUSTOMER_NEEDS } = constants;

type Props = {
  needsProductType?: string | null;
  needsType?: string | null;
};

const getIsExtrasComparerPage = ({ needsProductType, needsType }: Props) =>
  needsType === CUSTOMER_NEEDS.EXTRAS_COVER && needsProductType === CUSTOMER_NEEDS.ALL;

export default getIsExtrasComparerPage;
